import { render, staticRenderFns } from "./LabelAdmin.vue?vue&type=template&id=7a0a280f&scoped=true&"
import script from "./LabelAdmin.vue?vue&type=script&lang=js&"
export * from "./LabelAdmin.vue?vue&type=script&lang=js&"
import style0 from "./LabelAdmin.vue?vue&type=style&index=0&id=7a0a280f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0a280f",
  null
  
)

export default component.exports